var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlanet = function SvgPlanet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.017 27.874C2.914 35.966.171 42.96 2.606 45.394c3.428 3.429 15.771-3.428 27.428-15.223s18.652-24 15.223-27.428c-2.194-2.229-8.16 0-15.326 4.834"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M41.314 16.869a17.143 17.143 0 0 1-15.6 24.274 17.4 17.4 0 0 1-6.685-1.337M12 34.286a17.143 17.143 0 0 1 24-24"
  }))));
};
export default SvgPlanet;